<template>
    <div id="ad-account-list">
        <div class="mi-aal-header">
            <strong style="color: #1f1f1f; font-size: 14px;">{{ $t("metaInsights.selectAdAccount") }}</strong>
            <span style="color: #6b7280; font-size: 12px;">{{ $t("metaInsights.selectAdAccountDesc") }}</span>
        </div>
        <div class="mi-aal-list">
            <div
                v-for="acc in accounts"
                :key="acc.id"
                class="mi-aal-row"
                :class="{ 'mi-aal-selected': isSelected(acc) }"
                @click="select(acc)"
            >
                <div class="mi-aal-radio" :class="{ 'mi-aal-radio-checked': isSelected(acc) }">
                    <span class="mi-aal-dot" v-if="isSelected(acc)"></span>
                </div>
                <div class="mi-aal-info">
                    <div
                        class="mi-aal-name"
                        style="font-weight: 600; font-size: 14px; color: #1f1f1f; line-height: 1.4; word-break: break-word;"
                    >
                        {{ acc.name || acc.id }}
                    </div>
                    <div class="mi-aal-badges">
                        <span
                            class="mi-aal-badge"
                            style="background: #f0f0f0; color: #595959; font-family: ui-monospace, SFMono-Regular, monospace;"
                        >
                            {{ acc.account_id }}
                        </span>
                        <span
                            class="mi-aal-badge"
                            style="background: #fff7e6; color: #d48806;"
                        >
                            {{ acc.currency }}
                        </span>
                        <span
                            v-if="acc.business && acc.business.name"
                            class="mi-aal-badge"
                            style="background: #eef4ff; color: #1f6feb;"
                        >
                            <i class="material-icons" style="font-size: 12px;">business</i>
                            {{ acc.business.name }}
                        </span>
                        <span
                            v-if="acc.timezone_name"
                            class="mi-aal-badge"
                            style="background: #f6ffed; color: #389e0d;"
                        >
                            <i class="material-icons" style="font-size: 12px;">schedule</i>
                            {{ acc.timezone_name }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="mi-aal-empty" v-if="!accounts || accounts.length === 0">
                {{ $t("metaInsights.noAdAccounts") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdAccountList",
    props: {
        accounts: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            selectedId: this.value ? this.value.id : null,
        };
    },
    methods: {
        isSelected(acc) {
            return this.selectedId === acc.id;
        },
        select(acc) {
            this.selectedId = acc.id;
            this.$emit("input", acc);
            this.$emit("change", acc);
        },
    },
    watch: {
        value(val) {
            this.selectedId = val ? val.id : null;
        },
    },
};
</script>

<style lang="scss" scoped>
#ad-account-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .mi-aal-header {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .mi-aal-list {
        max-height: 360px;
        overflow-y: auto;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: #fff;
    }

    .mi-aal-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 10px 12px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
        transition: background 0.15s ease;

        &:hover {
            background: #f5f9ff;
        }

        &.mi-aal-selected {
            background: #eef6ff;
        }

        &:last-child {
            border-bottom: none;
        }
    }

    .mi-aal-radio {
        flex: 0 0 auto;
        width: 18px;
        height: 18px;
        border: 2px solid #c4c4c4;
        border-radius: 50%;
        margin-top: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color 0.15s ease;

        &.mi-aal-radio-checked {
            border-color: #1f6feb;
        }

        .mi-aal-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #1f6feb;
        }
    }

    .mi-aal-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }

    .mi-aal-badges {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .mi-aal-badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 11px;
        font-weight: 500;
        padding: 2px 8px;
        border-radius: 10px;
        line-height: 1.6;
        white-space: nowrap;
    }

    .mi-aal-empty {
        padding: 20px;
        text-align: center;
        color: #6b7280;
    }
}
</style>
